import { AnalyticsServiceInterface } from '~/modules/Analytics/Domain/AnalyticsServiceInterface'
import { BrowserAnalyticsService } from '~/modules/Analytics/Infrastructure/BrowserAnalyticsService'
import { ensureBrowserAnalyticsClient } from './browserAnalyticsRuntime'

class NoopAnalyticsService implements AnalyticsServiceInterface {
  async identify (): Promise<void> {
    return Promise.resolve()
  }

  async trackCheckoutStarted (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductPurchased (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductShared (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductMemoryRemoved (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductMemoryCreated (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductViewed (): Promise<void> {
    return Promise.resolve()
  }

  async trackProductMinted (): Promise<void> {
    return Promise.resolve()
  }

  async trackGalleryEnabled (): Promise<void> {
    return Promise.resolve()
  }

  async trackGalleryDisabled (): Promise<void> {
    return Promise.resolve()
  }

  async trackGalleryViewed (): Promise<void> {
    return Promise.resolve()
  }
}

const noopAnalyticsService = new NoopAnalyticsService()

export function getBrowserAnalyticsService (): BrowserAnalyticsService | null {
  if (typeof window === 'undefined') {
    return null
  }

  const analyticsClient = ensureBrowserAnalyticsClient()

  if (!analyticsClient) {
    return null
  }

  return new BrowserAnalyticsService(analyticsClient)
}

export function getAnalyticsService (): AnalyticsServiceInterface {
  return getBrowserAnalyticsService() || noopAnalyticsService
}

export function safeAnalyticsPage (): void {
  if (typeof window === 'undefined') {
    return
  }

  const analyticsClient = ensureBrowserAnalyticsClient()

  if (typeof analyticsClient?.page === 'function') {
    analyticsClient.page()
  }
}
